import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['auth/user']) {
    window.location = '/';
    return;
  }

  const roles = store.getters['auth/user'].roles;
  console.log(roles);
  if (roles.indexOf('teacher') === -1 && roles.indexOf('curator') === -1 && roles.indexOf('admin') === -1) {
    window.location = '/';
    return;
  }
  console.log(roles);

  next();
}
